module.exports = __webpack_public_path__ + "static/media/answer_logo.cd404ee5.png";